/**
 * Storage per le sessioni Drive che funziona anche nelle WebView:
 *  - localStorage quando disponibile (Android: setDomStorageEnabled(true); iOS: WKWebsiteDataStore.default());
 *  - se localStorage lancia (WebView senza DOM storage, Safari privato, quota piena) ricade su memoria;
 *  - se il wrapper nativo espone DriveApp.storageGet/storageSet/storageRemove (es. Keystore/Keychain),
 *    li usa come copia persistente sicura.
 * Mai loggare i valori: contengono token.
 */
import { getDriveBridge } from "./bridge";

const memory = new Map();

function nativeStore() {
  const b = getDriveBridge();
  return b && typeof b.storageGet === "function" && typeof b.storageSet === "function" ? b : null;
}

function local() {
  try {
    const ls = window.localStorage;
    const k = "__drive_probe__";
    ls.setItem(k, "1");
    ls.removeItem(k);
    return ls;
  } catch {
    return null;
  }
}

export function storageGet(key) {
  const n = nativeStore();
  if (n) {
    try {
      const v = n.storageGet(key);
      if (v !== undefined && v !== null && v !== "") return String(v);
    } catch {
      /* ignore */
    }
  }
  const ls = local();
  if (ls) {
    const v = ls.getItem(key);
    if (v !== null) return v;
  }
  return memory.has(key) ? memory.get(key) : null;
}

export function storageSet(key, value) {
  const v = String(value);
  memory.set(key, v);
  const ls = local();
  if (ls) {
    try {
      ls.setItem(key, v);
    } catch {
      /* quota: resta in memoria */
    }
  }
  const n = nativeStore();
  if (n) {
    try {
      n.storageSet(key, v);
    } catch {
      /* ignore */
    }
  }
}

export function storageRemove(key) {
  memory.delete(key);
  const ls = local();
  if (ls) ls.removeItem(key);
  const n = nativeStore();
  if (n && typeof n.storageRemove === "function") {
    try {
      n.storageRemove(key);
    } catch {
      /* ignore */
    }
  }
}

export function storageBackend() {
  if (nativeStore()) return "native";
  return local() ? "localStorage" : "memory";
}

export function __resetDriveMemoryStorage() {
  memory.clear();
}
